import Game from './scenes/Game';
import Intro from './scenes/Intro';
import End from './scenes/End';
import Instructions from './scenes/Instructions';

export default {
  /**
     * Add your scene classes here. Simply put the scene class.
     * Ex: `scenes: [MyScene,MyOtherScene]`
     * @type {{KEY:string}[]}
     */
  scenes: [Intro, Instructions, Game, End],

  /**
     * Set the first scene that should be loaded here. Must match one of the scenes' key found in the scenes array.
     * It is recommended you put `MyScene.KEY` here instead of using a string.
     * @type {string}
     */
  startScene: Intro.KEY,

  level: 1,
  score: 0,
  addNum: 12,
  MIN_ADD_VALUE: 5,
  BALL_SIZE: 50,
  BALL_SPEED: 0.35, // 0.35
  themePlaying: true
};
